import type { SwarmType } from '@/graphql/types';
import { isSwarmType } from '../typeGuards';

export type SwarmTypeOption = readonly [SwarmType, string];

export function getSwarmTypeOptionsOrThrow(
    value: unknown,
    path: string
): readonly SwarmTypeOption[] {
    if (!Array.isArray(value) || value.length === 0) {
        throw new Error(`Expected "${path}" to define SWARM type options.`);
    }

    const seen = new Set<SwarmType>();
    return value.map((option, index) => {
        if (
            !Array.isArray(option) ||
            option.length !== 2 ||
            !isSwarmType(option[0]) ||
            typeof option[1] !== 'string' ||
            option[1].length === 0
        ) {
            throw new Error(`Expected "${path}[${index}]" to be a valid SWARM type option.`);
        }

        if (seen.has(option[0])) {
            throw new Error(`Expected "${path}" to contain unique SWARM type options.`);
        }
        seen.add(option[0]);

        return [option[0], option[1]];
    });
}
